import React, {
  useEffect,
  useState,
} from "react";

import {
  Typography,
} from "@mui/material";

const formatElapsedTime = (
  totalSeconds,
) => {
  const safeSeconds =
    Math.max(
      0,
      Number(totalSeconds) || 0,
    );

  const hours =
    Math.floor(
      safeSeconds / 3600,
    );

  const minutes =
    Math.floor(
      (safeSeconds % 3600) /
        60,
    );

  const seconds =
    safeSeconds % 60;

  return [
    hours,
    minutes,
    seconds,
  ]
    .map((value) =>
      String(value).padStart(
        2,
        "0",
      ),
    )
    .join(":");
};

const ConsultationElapsedTimer = ({
  slotAt,
  serverNow,
  hardEndsAt,
}) => {
  const [
    elapsedSeconds,
    setElapsedSeconds,
  ] = useState(0);

  useEffect(() => {
    const slotAtMs =
      new Date(
        slotAt,
      ).getTime();

    const serverNowMs =
      new Date(
        serverNow,
      ).getTime();

    const hardEndsAtMs =
      new Date(
        hardEndsAt,
      ).getTime();

    if (
      !Number.isFinite(
        slotAtMs,
      ) ||
      !Number.isFinite(
        serverNowMs,
      )
    ) {
      setElapsedSeconds(0);

      return undefined;
    }

    /*
     * Synchronize the running timer
     * with the server clock once.
     *
     * After that, Date.now() is only
     * used to measure time passing.
     */
    const localStartedAtMs =
      Date.now();

    const updateTimer = () => {
      const localElapsedMs =
        Date.now() -
        localStartedAtMs;

      const calculatedNowMs =
        serverNowMs +
        localElapsedMs;

      const effectiveNowMs =
        Number.isFinite(
          hardEndsAtMs,
        )
          ? Math.min(
              calculatedNowMs,
              hardEndsAtMs,
            )
          : calculatedNowMs;

      const elapsedMs =
        Math.max(
          0,
          effectiveNowMs -
            slotAtMs,
        );

      setElapsedSeconds(
        Math.floor(
          elapsedMs / 1000,
        ),
      );
    };

    updateTimer();

    const intervalId =
      window.setInterval(
        updateTimer,
        1000,
      );

    return () => {
      window.clearInterval(
        intervalId,
      );
    };
  }, [
    slotAt,
    serverNow,
    hardEndsAt,
  ]);

  return (
    <Typography
      variant="body2"
      fontWeight={600}
    >
      {formatElapsedTime(
        elapsedSeconds,
      )}
    </Typography>
  );
};

export default ConsultationElapsedTimer;